import React, {useEffect} from "react";
import {
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {IndexPage} from "./components/IndexPage";
import {TariffsPage} from "./components/TariffsPage";
import {ContractsPage} from "./components/ContractsPage";
import {ReconciliationPage} from "./components/ReconciliationPage";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {useApolloClient} from "@apollo/client";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";
import {ReconciliationDetailsPage} from "~/apps/packages/finance/components/ReconciliationDetailsPage";


export const APP_NAME = "finance";
export const APP_VERSION = "1.0.0";


const FinanceApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "contractsBalance"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "tariffAgreements"});
    }, []);

    return (
        <AccessRequired title="Финансы">
            <BrowserRouter basename="/apps/finance">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="/tariffs" exact={true}>
                            <TariffsPage/>
                        </Route>
                        <Route path="/contracts" exact={true}>
                            <ContractsPage/>
                        </Route>
                        <Route path="/reconciliation/detailing" exact={true}>
                            <ReconciliationDetailsPage />
                        </Route>
                        <Route path="/reconciliation" exact={true}>
                            <ReconciliationPage/>
                        </Route>
                        <Route path="/" exact={true}>
                            <IndexPage/>
                        </Route>
                        <Route path="*">
                            <Redirect to="/"/>
                        </Route>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    );
}


export default FinanceApp;
